class MasterdataController implements ng.IComponentController {
    
    constructor() {
        'ngInject';
    }
}

export const masterdataComponent : ng.IComponentOptions = {
    controller : MasterdataController,
    template : require('./masterdata.html')
};



// WEBPACK FOOTER //
// ./~/@abosol/masterdata/src/masterdata.component.ts